import router from '@/router'
const isDevMode = process.env.NODE_ENV !== 'production'

function isUrlKoRoute (url) {
    return !!url.hash
}

function isUrlSalong (url) {
    if (isDevMode) {
        // If we are in dev mode and the given URL is from salonginstillinger test environment
        // We wanna navigate to the local host route
        return url.host === 'salong.test.odindata.no'
    }
    return url.host === window.location.host
}

function resolve (url) {
    let r = router.resolve(url.pathname)
    let internalRoute = r.resolved
    internalRoute = internalRoute && internalRoute.name ? internalRoute : null
    return internalRoute
}

export const getInternalRoute = (url) => {
    if (!url) return null
    let internalRoute = null

    try {
        let u = new URL(url)
        if (isUrlSalong(u) && !isUrlKoRoute(u)) {
            internalRoute = resolve(u)
        }
    } catch {
        internalRoute = null
    }
    return internalRoute
}

export default {
    getInternalRoute
}
